import React from 'react'
import "./net-income-table.scss"
import { useTranslation } from "react-i18next";
import { Table } from 'antd';
import TableNumber from "../../../../../atoms/table-number";


const NetIncomeTable = () => {
    const { t } = useTranslation();

    const columns = [
        {
            title: '',
            dataIndex: 'assets',
            key: 'assets',
            width: 200,
            fixed: 'left' as const,
            render: (text: any) => {
                let className
                if (text.title === 'Total Liabilities & Equity'
                    || text.title === 'Net Interest Income'
                    || text.title === 'Balance Account Asset'
                    || text.title === 'Total Assets'
                ) {
                    className = 'bold-blue'
                }
                else {
                    className = ''
                }

                return <div className='assets' >
                    <div className={className} >
                        {text.title}
                    </div>
                    <div>
                        {text.subTitle && <ul>
                            <li>{text.subTitle}</li>
                        </ul>}
                    </div>
                </div>
            }
        },
        {
            title: t("AssetLiability.recent12Month") + " 05/31/2024",
            children: [
                {
                    title: t("AssetLiability.avgBalance"),
                    dataIndex: '12MonthEnd1Balance',
                    key: '12MonthEnd1Balance',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: t("AssetLiability.avgYield"),
                    dataIndex: '12MonthEnd1Yield',
                    key: '12MonthEnd1Yield',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: t("AssetLiability.income"),
                    dataIndex: '12MonthEnd1Income',
                    key: '12MonthEnd1Income',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
            ],
        },
        {
            title: t("AssetLiability.with100Bps"),
            children: [
                {
                    title: t("AssetLiability.avgYield"),
                    dataIndex: '100Bp1Yield',
                    key: '100Bp1Yield',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: t("AssetLiability.income"),
                    dataIndex: '100Bp1Income',
                    key: '100Bp1Income',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
            ],
        },
        {
            title: t("AssetLiability.risk"),
            dataIndex: 'risk1',
            key: 'risk1',
            //width: 150,
            align: 'center' as const,
            render: (text: string) => <TableNumber value={text} />
        },
        {
            title: t("AssetLiability.rateShock"),
            dataIndex: 'rateShock1',
            key: 'rateShock1',
            //width: 150,
            align: 'center' as const,
            render: (text: string) => <TableNumber value={text} />
        },
        {
            title: t("AssetLiability.recent12Month") + " 04/30/2024",
            children: [
                {
                    title: t("AssetLiability.avgBalance"),
                    dataIndex: '12MonthEnd2Balance',
                    key: '12MonthEnd2Balance',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: t("AssetLiability.avgYield"),
                    dataIndex: '12MonthEnd2Yield',
                    key: '12MonthEnd2Yield',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: t("AssetLiability.income"),
                    dataIndex: '12MonthEnd2Income',
                    key: '12MonthEnd2Income',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
            ],
        },
        {
            title: t("AssetLiability.with100Bps"),
            children: [
                {
                    title: t("AssetLiability.avgYield"),
                    dataIndex: '100Bp2Yield',
                    key: '100Bp2Yield',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
                {
                    title: t("AssetLiability.income"),
                    dataIndex: '100Bp2Income',
                    key: '100Bp2Income',
                    //width: 150,
                    align: 'center' as const,
                    render: (text: string) => <TableNumber value={text} />
                },
            ],
        },
        {
            title: t("AssetLiability.risk"),
            dataIndex: 'risk2',
            key: 'risk2',
            //width: 150,
            align: 'center' as const,
            render: (text: string) => <TableNumber value={text} />
        },
        {
            title: t("AssetLiability.rateShock"),
            dataIndex: 'rateShock2',
            key: 'rateShock2',
            //width: 150,
            align: 'center' as const,
            render: (text: string) => <TableNumber value={text} />
        },
        {
            title: t("AssetLiability.riskChanges"),
            dataIndex: 'riskChanges',
            key: 'riskChanges',
            //width: 150,
            align: 'center' as const,
            render: (text: string) => <TableNumber value={text} />
        },
    ];

    let id = 1;

    const data = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Cash & Statutory Deposits",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "",
            "rateShock1": "",
            "12MonthEnd2Balance": "",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "",
            "rateShock2": "",
            "riskChanges": ""
        },
        {
            id: id++,
            "key": 2,
            "assets": {
                "title": "Due From Banks",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "14,101",
            "12MonthEnd1Yield": "1.01",
            "12MonthEnd1Income": "143",
            "100Bp1Yield": "1.36",
            "100Bp1Income": "192",
            "risk1": "49",
            "rateShock1": "0.35",
            "12MonthEnd2Balance": "15,818",
            "12MonthEnd2Yield": "0.96",
            "12MonthEnd2Income": "151",
            "100Bp2Yield": "1.30",
            "100Bp2Income": "206",
            "risk2": "55",
            "rateShock2": "0.34",
            "riskChanges": "(6)"
        },
        {
            id: id++,
            "key": 3,
            "assets": {
                "title": "Loans & Advances (Good)",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "134,002",
            "12MonthEnd1Yield": "3.55",
            "12MonthEnd1Income": "4,785",
            "100Bp1Yield": "3.98",
            "100Bp1Income": "5,360",
            "risk1": "575",
            "rateShock1": "0.43",
            "12MonthEnd2Balance": "131,375",
            "12MonthEnd2Yield": "3.56",
            "12MonthEnd2Income": "4,706",
            "100Bp2Yield": "3.99",
            "100Bp2Income": "5,273",
            "risk2": "567",
            "rateShock2": "0.43",
            "riskChanges": "8"
        },
        {
            id: id++,
            "key": 4,
            "assets": {
                "title": "Overdrafts",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "8,814",
            "12MonthEnd1Yield": "6.55",
            "12MonthEnd1Income": "577",
            "100Bp1Yield": "6.55",
            "100Bp1Income": "577",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "8,707",
            "12MonthEnd2Yield": "6.56",
            "12MonthEnd2Income": "571",
            "100Bp2Yield": "6.56",
            "100Bp2Income": "571",
            "risk2": "0",
            "rateShock2": "0.00",
            "riskChanges": "0"
        },
        {
            id: id++,
            "key": 5,
            "assets": {
                "title": "Wholesale Loans",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "19,536",
            "12MonthEnd1Yield": "1.29",
            "12MonthEnd1Income": "253",
            "100Bp1Yield": "1.92",
            "100Bp1Income": "375",
            "risk1": "122",
            "rateShock1": "0.63",
            "12MonthEnd2Balance": "19,182",
            "12MonthEnd2Yield": "1.21",
            "12MonthEnd2Income": "230",
            "100Bp2Yield": "1.86",
            "100Bp2Income": "357",
            "risk2": "127",
            "rateShock2": "0.66",
            "riskChanges": "(4)"
        },
        {
            id: id++,
            "key": 6,
            "assets": {
                "title": "Commercial Loans",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "69,614",
            "12MonthEnd1Yield": "3.36",
            "12MonthEnd1Income": "2,353",
            "100Bp1Yield": "4.01",
            "100Bp1Income": "2,805",
            "risk1": "452",
            "rateShock1": "0.65",
            "12MonthEnd2Balance": "68,137",
            "12MonthEnd2Yield": "3.36",
            "12MonthEnd2Income": "2,304",
            "100Bp2Yield": "4.01",
            "100Bp2Income": "2,744",
            "risk2": "440",
            "rateShock2": "0.64",
            "riskChanges": "12"
        },
        {
            id: id++,
            "key": 7,
            "assets": {
                "title": "Consumer Loans",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "24,583",
            "12MonthEnd1Yield": "4.01",
            "12MonthEnd1Income": "996",
            "100Bp1Yield": "4.01",
            "100Bp1Income": "996",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "24,438",
            "12MonthEnd2Yield": "4.11",
            "12MonthEnd2Income": "1,017",
            "100Bp2Yield": "4.11",
            "100Bp2Income": "1,017",
            "risk2": "0",
            "rateShock2": "0.00",
            "riskChanges": "0"
        },
        {
            id: id++,
            "key": 8,
            "assets": {
                "title": "Credit Cards",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "1,056",
            "12MonthEnd1Yield": "23.40",
            "12MonthEnd1Income": "250",
            "100Bp1Yield": "23.40",
            "100Bp1Income": "250",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "1,026",
            "12MonthEnd2Yield": "23.40",
            "12MonthEnd2Income": "243",
            "100Bp2Yield": "23.40",
            "100Bp2Income": "243",
            "risk2": "0",
            "rateShock2": "0.00",
            "riskChanges": "0"
        },
        {
            id: id++,
            "key": 9,
            "assets": {
                "title": "Mortgage Loans",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "10,399",
            "12MonthEnd1Yield": "3.38",
            "12MonthEnd1Income": "356",
            "100Bp1Yield": "3.38",
            "100Bp1Income": "356",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "9,885",
            "12MonthEnd2Yield": "3.40",
            "12MonthEnd2Income": "340",
            "100Bp2Yield": "3.40",
            "100Bp2Income": "340",
            "risk2": "0",
            "rateShock2": "0.00",
            "riskChanges": "0"
        },
        {
            id: id++,
            "key": 10,
            "assets": {
                "title": "Investment",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "38,801",
            "12MonthEnd1Yield": "1.69",
            "12MonthEnd1Income": "845",
            "100Bp1Yield": "2.04",
            "100Bp1Income": "977",
            "risk1": "132",
            "rateShock1": "0.34",
            "12MonthEnd2Balance": "43,413",
            "12MonthEnd2Yield": "1.69",
            "12MonthEnd2Income": "924",
            "100Bp2Yield": "1.96",
            "100Bp2Income": "1,045",
            "risk2": "121",
            "rateShock2": "0.27",
            "riskChanges": "12"
        },
        {
            id: id++,
            "key": 11,
            "assets": {
                "title": "T-Bills",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "19,068",
            "12MonthEnd1Yield": "0.54",
            "12MonthEnd1Income": "235",
            "100Bp1Yield": "0.96",
            "100Bp1Income": "316",
            "risk1": "81",
            "rateShock1": "0.43",
            "12MonthEnd2Balance": "19,594",
            "12MonthEnd2Yield": "0.48",
            "12MonthEnd2Income": "231",
            "100Bp2Yield": "0.86",
            "100Bp2Income": "305",
            "risk2": "75",
            "rateShock2": "0.38",
            "riskChanges": "6"
        },
        {
            id: id++,
            "key": 12,
            "assets": {
                "title": "Government Bonds",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "7,410",
            "12MonthEnd1Yield": "3.36",
            "12MonthEnd1Income": "287",
            "100Bp1Yield": "3.44",
            "100Bp1Income": "293",
            "risk1": "6",
            "rateShock1": "0.08",
            "12MonthEnd2Balance": "7,248",
            "12MonthEnd2Yield": "3.19",
            "12MonthEnd2Income": "273",
            "100Bp2Yield": "3.29",
            "100Bp2Income": "279",
            "risk2": "7",
            "rateShock2": "0.09",
            "riskChanges": "(1)"
        },
        {
            id: id++,
            "key": 13,
            "assets": {
                "title": "Zero Coupon Bonds",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "163",
            "12MonthEnd1Yield": "0.40",
            "12MonthEnd1Income": "3",
            "100Bp1Yield": "0.53",
            "100Bp1Income": "3",
            "risk1": "0",
            "rateShock1": "0.13",
            "12MonthEnd2Balance": "183",
            "12MonthEnd2Yield": "0.34",
            "12MonthEnd2Income": "3",
            "100Bp2Yield": "0.46",
            "100Bp2Income": "3",
            "risk2": "0",
            "rateShock2": "0.12",
            "riskChanges": "(0)"
        },
        {
            id: id++,
            "key": 14,
            "assets": {
                "title": "FRN",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "4,539",
            "12MonthEnd1Yield": "1.26",
            "12MonthEnd1Income": "65",
            "100Bp1Yield": "2.06",
            "100Bp1Income": "102",
            "risk1": "37",
            "rateShock1": "0.80",
            "12MonthEnd2Balance": "4,484",
            "12MonthEnd2Yield": "1.28",
            "12MonthEnd2Income": "65",
            "100Bp2Yield": "2.05",
            "100Bp2Income": "100",
            "risk2": "35",
            "rateShock2": "0.77",
            "riskChanges": "2"
        },
        {
            id: id++,
            "key": 15,
            "assets": {
                "title": "International Portfolios",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "6,988",
            "12MonthEnd1Yield": "3.51",
            "12MonthEnd1Income": "248",
            "100Bp1Yield": "3.55",
            "100Bp1Income": "251",
            "risk1": "3",
            "rateShock1": "0.04",
            "12MonthEnd2Balance": "6,960",
            "12MonthEnd2Yield": "3.48",
            "12MonthEnd2Income": "245",
            "100Bp2Yield": "3..52",
            "100Bp2Income": "249",
            "risk2": "3",
            "rateShock2": "0.05",
            "riskChanges": "(0)"
        },
        {
            id: id++,
            "key": 17,
            "assets": {
                "title": "CDs & BAs",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "633",
            "12MonthEnd1Yield": "0.48",
            "12MonthEnd1Income": "6",
            "100Bp1Yield": "1.28",
            "100Bp1Income": "11",
            "risk1": "5",
            "rateShock1": "0.80",
            "12MonthEnd2Balance": "262",
            "12MonthEnd2Yield": "0.50",
            "12MonthEnd2Income": "4",
            "100Bp2Yield": "0.59",
            "100Bp2Income": "4",
            "risk2": "0",
            "rateShock2": "0.09",
            "riskChanges": "5"
        },
        {
            id: id++,
            "key": 18,
            "assets": {
                "title": "",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "",
            "rateShock1": "",
            "12MonthEnd2Balance": "",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "",
            "rateShock2": "",
            "riskChanges": ""
        },
        {
            id: id++,
            "key": 19,
            "assets": {
                "title": "Other Assets",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "0",
            "rateShock2": "0.32",
            "riskChanges": "123"
        },
        {
            id: id++,
            "key": 20,
            "assets": {
                "title": "Balance Account Asset",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "0",
            "rateShock2": "0.00",
            "riskChanges": "0"
        },
        {
            id: id++,
            "key": 21,
            "assets": {
                "title": "Interst Bearing Assets",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "186,904",
            "12MonthEnd1Yield": "2.97",
            "12MonthEnd1Income": "5,773",
            "100Bp1Yield": "3.38",
            "100Bp1Income": "6,529",
            "risk1": "756",
            "rateShock1": "0.40",
            "12MonthEnd2Balance": "190,606",
            "12MonthEnd2Yield": "2.92",
            "12MonthEnd2Income": "5,781",
            "100Bp2Yield": "3.30",
            "100Bp2Income": "6,523",
            "risk2": "742",
            "rateShock2": "0.39",
            "riskChanges": "14"
        },
        {
            id: id++,
            "key": 22,
            "assets": {
                "title": "Total Assets",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "186,904",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "",
            "rateShock1": "",
            "12MonthEnd2Balance": "190,606",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "",
            "rateShock2": "",
            "riskChanges": ""
        }
    ];

    const liabilitiesData = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Non Interest Bearing Deposits",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(65,354)",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "",
            "rateShock1": "",
            "12MonthEnd2Balance": "(65,482)",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "",
            "rateShock2": "",
            "riskChanges": ""
        },
        {
            id: id++,
            "key": 2,
            "assets": {
                "title": "Interest Bearing Deposits",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(85,203)",
            "12MonthEnd1Yield": "1.01",
            "12MonthEnd1Income": "(866)",
            "100Bp1Yield": "1.58",
            "100Bp1Income": "(1,346)",
            "risk1": "(481)",
            "rateShock1": "0.56",
            "12MonthEnd2Balance": "(84,406)",
            "12MonthEnd2Yield": "0.99",
            "12MonthEnd2Income": "(838)",
            "100Bp2Yield": "1.65",
            "100Bp2Income": "(1,401)",
            "risk2": "(563)",
            "rateShock2": "0.66",
            "riskChanges": "82"
        },
        {
            id: id++,
            "key": 3,
            "assets": {
                "title": "Call/Notice Deposits",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(70)",
            "12MonthEnd1Yield": "0.59",
            "12MonthEnd1Income": "(0)",
            "100Bp1Yield": "0.59",
            "100Bp1Income": "(0)",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "(63)",
            "12MonthEnd2Yield": "0.59",
            "12MonthEnd2Income": "(0)",
            "100Bp2Yield": "0.59",
            "100Bp2Income": "(0)",
            "risk2": "0",
            "rateShock2": "0.00",
            "riskChanges": "0"
        },
        {
            id: id++,
            "key": 4,
            "assets": {
                "title": "Time Deposits",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(84,183)",
            "12MonthEnd1Yield": "1.01",
            "12MonthEnd1Income": "(855)",
            "100Bp1Yield": "1.57",
            "100Bp1Income": "(1,327)",
            "risk1": "(472)",
            "rateShock1": "0.56",
            "12MonthEnd2Balance": "(83,579)",
            "12MonthEnd2Yield": "0.99",
            "12MonthEnd2Income": "(830)",
            "100Bp2Yield": "1.65",
            "100Bp2Income": "(1,386)",
            "risk2": "(556)",
            "rateShock2": "0.66",
            "riskChanges": "84"
        },
        {
            id: id++,
            "key": 5,
            "assets": {
                "title": "Saving Account",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(361)",
            "12MonthEnd1Yield": "1.04",
            "12MonthEnd1Income": "(4)",
            "100Bp1Yield": "1.94",
            "100Bp1Income": "(7)",
            "risk1": "(3)",
            "rateShock1": "0.91",
            "12MonthEnd2Balance": "(361)",
            "12MonthEnd2Yield": "1.04",
            "12MonthEnd2Income": "(4)",
            "100Bp2Yield": "1.94",
            "100Bp2Income": "(7)",
            "risk2": "(3)",
            "rateShock2": "0.90",
            "riskChanges": "(0)"
        },
        {
            id: id++,
            "key": 6,
            "assets": {
                "title": "Customer Repos",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(589)",
            "12MonthEnd1Yield": "1.06",
            "12MonthEnd1Income": "(6)",
            "100Bp1Yield": "1.96",
            "100Bp1Income": "(12)",
            "risk1": "(5)",
            "rateShock1": "0.91",
            "12MonthEnd2Balance": "(403)",
            "12MonthEnd2Yield": "1.06",
            "12MonthEnd2Income": "(4)",
            "100Bp2Yield": "1.95",
            "100Bp2Income": "(8)",
            "risk2": "(4)",
            "rateShock2": "0.89",
            "riskChanges": "(2)"
        },
        {
            id: id++,
            "key": 7,
            "assets": {
                "title": "Due To Banks",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(4,843)",
            "12MonthEnd1Yield": "0.78",
            "12MonthEnd1Income": "(37)",
            "100Bp1Yield": "1.39",
            "100Bp1Income": "(67)",
            "risk1": "(30)",
            "rateShock1": "0.61",
            "12MonthEnd2Balance": "(6,647)",
            "12MonthEnd2Yield": "0.64",
            "12MonthEnd2Income": "(43)",
            "100Bp2Yield": "1.39",
            "100Bp2Income": "(93)",
            "risk2": "(50)",
            "rateShock2": "0.75",
            "riskChanges": "20"
        },
        {
            id: id++,
            "key": 8,
            "assets": {
                "title": "Debt Security",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(4,000)",
            "12MonthEnd1Yield": "1.78",
            "12MonthEnd1Income": "(71)",
            "100Bp1Yield": "2.66",
            "100Bp1Income": "(106)",
            "risk1": "(35)",
            "rateShock1": "0.88",
            "12MonthEnd2Balance": "(4,000)",
            "12MonthEnd2Yield": "1.76",
            "12MonthEnd2Income": "(70)",
            "100Bp2Yield": "2.72",
            "100Bp2Income": "(109)",
            "risk2": "(38)",
            "rateShock2": "0.96",
            "riskChanges": "3"
        },
        {
            id: id++,
            "key": 9,
            "assets": {
                "title": "Other Liabilities",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "",
            "rateShock1": "",
            "12MonthEnd2Balance": "",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "",
            "rateShock2": "",
            "riskChanges": ""
        },
        {
            id: id++,
            "key": 10,
            "assets": {
                "title": "Balance Account Liability",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "0",
            "rateShock2": "0.00",
            "riskChanges": "0"
        },
        {
            id: id++,
            "key": 11,
            "assets": {
                "title": "Total Interest Expenses",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(94,045)",
            "12MonthEnd1Yield": "1.03",
            "12MonthEnd1Income": "(974)",
            "100Bp1Yield": "1.61",
            "100Bp1Income": "(1,520)",
            "risk1": "(546)",
            "rateShock1": "0.58",
            "12MonthEnd2Balance": "(95,053)",
            "12MonthEnd2Yield": "1.00",
            "12MonthEnd2Income": "(952)",
            "100Bp2Yield": "1.68",
            "100Bp2Income": "(1,603)",
            "risk2": "(651)",
            "rateShock2": "0.68",
            "riskChanges": "105"
        },
        {
            id: id++,
            "key": 12,
            "assets": {
                "title": "Total Liability",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(159,400)",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "",
            "rateShock1": "",
            "12MonthEnd2Balance": "(160,535)",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "",
            "rateShock2": "",
            "riskChanges": ""
        },
        {
            id: id++,
            "key": 13,
            "assets": {
                "title": "Total Equity",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "",
            "rateShock1": "",
            "12MonthEnd2Balance": "",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "",
            "rateShock2": "",
            "riskChanges": ""
        },
        {
            id: id++,
            "key": 14,
            "assets": {
                "title": "Total Liabilities & Equity",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "(159,400)",
            "12MonthEnd1Yield": "",
            "12MonthEnd1Income": "",
            "100Bp1Yield": "",
            "100Bp1Income": "",
            "risk1": "",
            "rateShock1": "",
            "12MonthEnd2Balance": "(160,535)",
            "12MonthEnd2Yield": "",
            "12MonthEnd2Income": "",
            "100Bp2Yield": "",
            "100Bp2Income": "",
            "risk2": "",
            "rateShock2": "",
            "riskChanges": ""
        }
    ];


    const totalOffBalanceData = [
        {
            key: 1,
            assets: {
                title: "Total Off Balance Sheet",
                subTitle: ""
            },
            "12MonthEnd1Balance": "0",
            "12MonthEnd1Yield": "0.00",
            "12MonthEnd1Income": "0",
            "100Bp1Yield": "0.00",
            "100Bp1Income": "0",
            "risk1": "0",
            "rateShock1": "0.00",
            "12MonthEnd2Balance": "0",
            "12MonthEnd2Yield": "0.00",
            "12MonthEnd2Income": "0",
            "100Bp2Yield": "0.00",
            "100Bp2Income": "0",
            "risk2": "0",
            "rateShock2": "0.00",
            "riskChanges": "0"
        }
    ];


    const netIncomeData = [
        {
            id: id++,
            "key": 1,
            "assets": {
                "title": "Net Interest Income",
                "subTitle": ""
            },
            "12MonthEnd1Balance": "",
            "12MonthEnd1Yield": "0.00%",
            "12MonthEnd1Income": "4,799",
            "100Bp1Yield": "0.00%",
            "100Bp1Income": "5,009",
            "risk1": "210",
            "rateShock1": "",
            "12MonthEnd2Balance": "",
            "12MonthEnd2Yield": "0.00%",
            "12MonthEnd2Income": "4,829",
            "100Bp2Yield": "0.00%",
            "100Bp2Income": "4,920",
            "risk2": "91",
            "rateShock2": "",
            "riskChanges": "119"
        }
    ];

    return (
        <div className='net-income-wrapper' >
            <div className='net-income-table'>
                <div className="net-income-table__heading">{t("AssetLiability.comparativeNetRisk")}</div>
                <div className="net-income-table__date">CAD {t("AssetLiability.inMillions")}</div>
                <div className="net-income-table__table" >
                    <Table
                        columns={columns}
                        dataSource={data}
                        bordered
                        scroll={{ x: 1360 }}
                        pagination={false}
                        rowClassName={(record, index) => {

                            if (record.key === 21) {
                                return 'net-income-table__orange';
                            } else if (record.key === 22) {
                                return 'net-income-table__bold-blue';
                            }
                            else if (record.key === 17 || record.key === 1 || record.key === 20) {
                                return 'net-income-table__bold-white';
                            }
                            else if (index % 2 === 0 || record.key === 15 || record.key === 16) {
                                return 'net-income-table__table__white';
                            }
                            else {
                                return 'net-income-table__light-blue';
                            }
                        }}
                    />
                </div>



                <div className="net-income-table__table liabilities" >
                    <Table
                        columns={columns}
                        dataSource={liabilitiesData}
                        bordered
                        scroll={{ x: 1360 }}
                        pagination={false}
                        rowClassName={(record, index) => {

                            if (record.key === 11) {
                                return 'net-income-table__orange';
                            } else if (record.key === 14) {
                                return 'net-income-table__bold-blue';
                            }
                            else if (record.key === 10) {
                                return 'net-income-table__bold-blue';
                            }
                            else if (index % 2 === 0 || record.key === 12 || record.key === 13) {
                                return 'net-income-table__table__white';
                            }
                            else {
                                return 'net-income-table__light-blue';
                            }
                        }}
                    />
                </div>

                <div className="net-income-table__table total-liabilities" >
                    <Table
                        columns={columns}
                        dataSource={totalOffBalanceData}
                        bordered
                        scroll={{ x: 1360 }}
                        pagination={false}
                        rowClassName='net-income-table__yellow'
                    />
                </div>

                <div className="net-income-table__table total-liabilities" >
                    <Table
                        columns={columns}
                        dataSource={netIncomeData}
                        bordered
                        scroll={{ x: 1360 }}
                        pagination={false}
                        rowClassName='net-income-table__bold-blue'
                    />
                </div>
            </div>
        </div>
    )
}

export default NetIncomeTable